import { IDependent } from '../../../redux/slices/PolicyListSlice/types';

export const getDependentsOnSelectedParentType = (dependents: IDependent[],
    selectedParentType: string): IDependent[] => {
    return dependents.filter((dep: IDependent) => dep?.relationship.toLowerCase() === selectedParentType);
};
